const {
	default: { breakLarge },
} = require('util/sass-variables');
const { stuttering, default: onWidthResize } = require('util/onWidthResize');
const { DELAY_DEBOUNCE } = require('util/consts');
const { mediaQueryMin } = require('util/functions');
const FixedIn = require('util/FixedIn');

module.exports = {
	async init() {
		this.isSticky = this.root.classList.contains('social-share-is-sticky');
		if (this.isSticky) {
			await this.initSticky();
			onWidthResize(
				this.onResize.bind(this),
				stuttering.DEBOUNCE,
				DELAY_DEBOUNCE,
			);
			this.onResize();
		}
	},
	async initSticky() {
		this.fixingManager = Object.create(FixedIn);
		const container = this.root.parentElement.parentElement;
		await this.fixingManager.init(this.root, container, 100, 100);
	},
	onResize() {
		if (mediaQueryMin(breakLarge)) this.fixingManager.activate();
		else this.fixingManager.deactivate();
	},
};
